var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "exclude-outside-click cursor-pointer",
      class: _vm.getClasses(),
      on: { click: _vm.showField }
    },
    [
      (_vm.customField.field_key == "notes_research" ||
        _vm.customField.field_key == "department_detail" ||
        _vm.customField.field_key == "cap_communication") &&
      (_vm.$router.currentRoute.name == "departmentDeliverable" ||
        _vm.$router.currentRoute.name == "calendar")
        ? _c("div", { staticClass: "field-header" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showLabel,
                    expression: "showLabel"
                  }
                ],
                staticClass: "field-label"
              },
              [_vm._v(_vm._s(_vm.customField.label))]
            )
          ])
        : _c("div", [
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showLabel,
                    expression: "showLabel"
                  }
                ],
                staticClass:
                  "text-uppercase exclude-outside-click field-label p-0 cursor-pointer"
              },
              [_vm._v(_vm._s(_vm.customField.label))]
            )
          ]),
      _vm._v(" "),
      _vm.customField.field_type == "text"
        ? _c("div", { staticClass: "text-field-wrap" }, [
            _c("div", { staticClass: "text-field" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    }
                  ],
                  staticClass: "exclude-outside-click edit-d-title"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.customField.value ? _vm.customField.value : "N/A"
                    )
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editing,
                    expression: "editing"
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customField.value,
                    expression: "customField.value"
                  }
                ],
                ref: "customInput",
                staticClass: "form-control",
                attrs: { placeholder: _vm.customField.label, type: "text" },
                domProps: { value: _vm.customField.value },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    _vm.editing = false
                  },
                  blur: function($event) {
                    _vm.editing = false
                  },
                  change: function($event) {
                    return _vm.updateDepartmentFieldValue(_vm.customField)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.customField, "value", $event.target.value)
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "currency"
        ? _c("div", { staticClass: "text-field-wrap" }, [
            _c(
              "div",
              { staticClass: "currency-field" },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editing,
                        expression: "!editing"
                      }
                    ],
                    staticClass: "exclude-outside-click edit-d-title"
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.customField.value
                          ? _vm.formatPrice(_vm.customField.value)
                          : "$0.00"
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-input-group",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      },
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.outside,
                        expression: "outside"
                      }
                    ],
                    attrs: { prepend: "$" }
                  },
                  [
                    _c("b-form-input", {
                      ref: "customInput",
                      attrs: {
                        placeholder: _vm.customField.label,
                        type: "text"
                      },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          _vm.editing = false
                        },
                        blur: function($event) {
                          _vm.editing = false
                        },
                        change: function($event) {
                          return _vm.updateDepartmentFieldValue(_vm.customField)
                        }
                      },
                      model: {
                        value: _vm.customField.value,
                        callback: function($$v) {
                          _vm.$set(_vm.customField, "value", $$v)
                        },
                        expression: "customField.value"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "requisition_number" &&
      (_vm.$router.currentRoute.name == "departmentDeliverable" ||
        _vm.$router.currentRoute.name == "calendar")
        ? _c(
            "div",
            { staticClass: "requisition-number-field-wrap" },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    }
                  ],
                  staticClass: "exclude-outside-click edit-d-title"
                },
                [_vm._v("#" + _vm._s(_vm.customField.value))]
              ),
              _vm._v(" "),
              _c(
                "b-input-group",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editing,
                      expression: "editing"
                    },
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    }
                  ],
                  attrs: { prepend: "#" }
                },
                [
                  _c("b-form-input", {
                    ref: "customInput",
                    attrs: { placeholder: _vm.customField.label, type: "text" },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.editing = false
                      },
                      blur: function($event) {
                        _vm.editing = false
                      },
                      change: function($event) {
                        return _vm.updateDepartmentFieldValue(_vm.customField)
                      }
                    },
                    model: {
                      value: _vm.customField.value,
                      callback: function($$v) {
                        _vm.$set(_vm.customField, "value", $$v)
                      },
                      expression: "customField.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "color_picker" &&
      (_vm.$router.currentRoute.name == "departmentDeliverable" ||
        _vm.$router.currentRoute.name == "calendar")
        ? _c("div", { staticClass: "color-picker-field-wrap detail" }, [
            _c(
              "div",
              { staticClass: "text-field" },
              [
                _c("twitter-picker", {
                  on: {
                    input: function($event) {
                      _vm.customField.value = _vm.color
                      _vm.updateDepartmentFieldValue(_vm.customField)
                    }
                  },
                  model: {
                    value: _vm.color,
                    callback: function($$v) {
                      _vm.color = $$v
                    },
                    expression: "color"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "color_picker" &&
      _vm.$router.currentRoute.name == "department"
        ? _c("div", { staticClass: "color-picker-field-wrap" }, [
            _c(
              "div",
              { staticClass: "text-field" },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editing,
                        expression: "!editing"
                      }
                    ],
                    staticClass: "exclude-outside-click",
                    staticStyle: {
                      padding: "5px 10px",
                      "border-radius": "10px"
                    },
                    style: {
                      background: _vm.customField.value
                        ? _vm.customField.value
                        : "transparent",
                      color: _vm.customField.value
                        ? "var(--wf-secondary)"
                        : "var(--hover-grey)"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.customField.value ? _vm.customField.value : "N/A"
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c("twitter-picker", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editing,
                      expression: "editing"
                    },
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    }
                  ],
                  on: {
                    input: function($event) {
                      _vm.customField.value = _vm.color
                      _vm.updateDepartmentFieldValue(_vm.customField)
                    }
                  },
                  model: {
                    value: _vm.color,
                    callback: function($$v) {
                      _vm.color = $$v
                    },
                    expression: "color"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "requisition_number" &&
      _vm.$router.currentRoute.name != "departmentDeliverable" &&
        _vm.$router.currentRoute.name != "calendar"
        ? _c("div", { staticClass: "text-field-wrap" }, [
            _c("div", { staticClass: "requisition_number-field text-field" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    }
                  ],
                  staticClass: "exclude-outside-click edit-d-title"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.customField.value ? _vm.customField.value : "N/A"
                    )
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editing,
                    expression: "editing"
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customField.value,
                    expression: "customField.value"
                  }
                ],
                ref: "customInput",
                staticClass: "form-control",
                attrs: { placeholder: _vm.customField.label, type: "text" },
                domProps: { value: _vm.customField.value },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    _vm.editing = false
                  },
                  blur: function($event) {
                    _vm.editing = false
                  },
                  change: function($event) {
                    return _vm.updateDepartmentFieldValue(_vm.customField)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.customField, "value", $event.target.value)
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "priority"
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "ml-0 priority-rating",
                on: {
                  click: function($event) {
                    return _vm.setPriority(_vm.customField)
                  }
                }
              },
              [
                _c("vue-star-rate", {
                  key: "del-priority-" + Math.random() + _vm.deliverable.id,
                  attrs: {
                    rateRange: _vm.customField.value
                      ? Number(_vm.customField.value)
                      : 0,
                    maxIcon: 5,
                    iconHeight: 17,
                    iconWidth: 17,
                    hasCounter: false,
                    iconColor: "var(--wf-primary)",
                    iconColorHover: "var(--wf-primary)",
                    iconShape: "circle"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_key == "department_due_date"
        ? _c(
            "div",
            {
              ref: "refDatepickerWrapper",
              staticClass: "datepicker-field-wrap field-wrap-datepicker",
              on: {
                click: function($event) {
                  return _vm.findPosition()
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "exclude-outside-click edit-d-title" },
                [
                  _vm.customField.value
                    ? _c("span", { staticClass: "exclude-outside-click" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.customField.value,
                              "DD MMM, YYYY"
                            )
                          )
                        )
                      ])
                    : _c("span", { staticClass: "exclude-outside-click" }, [
                        _vm._v("No Deadline")
                      ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-field" },
                [
                  _c(
                    "vuejs-datepicker",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editing,
                          expression: "editing"
                        }
                      ],
                      ref: "customDatepicker",
                      attrs: {
                        format: _vm.customDateFormat,
                        name: "due_date",
                        "input-class": "custom-datepicker form-control",
                        typeable: true
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateDepartmentFieldValue(_vm.customField)
                        },
                        selected: function($event) {
                          _vm.dateSelected = true
                        }
                      },
                      model: {
                        value: _vm.customField.value,
                        callback: function($$v) {
                          _vm.$set(_vm.customField, "value", $$v)
                        },
                        expression: "customField.value"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "calender-header",
                          attrs: { slot: "beforeCalendarHeader" },
                          slot: "beforeCalendarHeader"
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "remove-dl-btn",
                              attrs: { variant: "text" },
                              on: { click: _vm.resetDeadline }
                            },
                            [_vm._v("Remove Deadline")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "today-btn",
                              attrs: { variant: "text" },
                              on: { click: _vm.onToday }
                            },
                            [_vm._v("Today")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "wysiwyg"
        ? _c(
            "div",
            { staticClass: "field-wrap" },
            [
              _c("ckeditor", {
                ref: "customInput",
                attrs: {
                  editorUrl: "/js/ckeditor/ckeditor.js",
                  id: "custom-field",
                  config: _vm.editorConfig
                },
                on: {
                  input: function($event) {
                    return _vm.setChanged(_vm.customField, true)
                  },
                  blur: function($event) {
                    return _vm.checkChangedFieldValue(_vm.customField)
                  },
                  ready: function($event) {
                    return _vm.setChanged(_vm.customField, false)
                  }
                },
                model: {
                  value: _vm.customField.value,
                  callback: function($$v) {
                    _vm.$set(_vm.customField, "value", $$v)
                  },
                  expression: "customField.value"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "textarea"
        ? _c("div", { staticClass: "field-wrap" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.editing,
                    expression: "!editing"
                  },
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true }
                  }
                ],
                staticClass: "exclude-outside-click field-value text-hover-bg",
                attrs: { title: _vm.customField.value }
              },
              [_vm._v(_vm._s(_vm.customField.value || "Click to set..."))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "custom-field" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editing,
                    expression: "editing"
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customField.value,
                    expression: "customField.value"
                  }
                ],
                ref: "customInput",
                staticClass: "form-control custom-inputs",
                attrs: { rows: _vm.rows },
                domProps: { value: _vm.customField.value },
                on: {
                  change: function($event) {
                    return _vm.updateDepartmentFieldValue(_vm.customField)
                  },
                  blur: function($event) {
                    _vm.editing = false
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.customField, "value", $event.target.value)
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "department_coordinator"
        ? _c("div", { staticClass: "field-wrap" }, [
            _vm.departmentCoordinator
              ? _c(
                  "div",
                  {
                    staticClass:
                      "info-bubbles cursor-pointer exclude-outside-click",
                    on: { click: _vm.showAddCoordinator }
                  },
                  [
                    _vm._l(_vm.departmentCoordinator, function(
                      coordinator,
                      index
                    ) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.editing,
                              expression: "!editing"
                            },
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.html",
                              modifiers: { hover: true, html: true }
                            }
                          ],
                          staticClass:
                            "initials badge badge-primary exclude-outside-click department-coordinator",
                          attrs: { title: coordinator.name }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("textInitials")(coordinator.name))
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.departmentCoordinator.length == 0
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.editing,
                                expression: "!editing"
                              }
                            ],
                            staticClass:
                              "exclude-outside-click badge badge-gray department-coordinator"
                          },
                          [_vm._v("No Coordinator")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("plus-button", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editing,
                          expression: "!editing"
                        }
                      ],
                      staticClass: "tagged-tags"
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "custom-field" },
              [
                _c("multiselect", {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editing,
                      expression: "editing"
                    }
                  ],
                  ref: "departmentCoordinator",
                  attrs: {
                    options: _vm.allUsers,
                    "option-height": 42,
                    "show-labels": false,
                    multiple: true,
                    label: "name",
                    "track-by": "id"
                  },
                  on: {
                    close: function($event) {
                      _vm.editing = false
                    },
                    input: function($event) {
                      return _vm.setDepartmentCoordinator()
                    }
                  },
                  model: {
                    value: _vm.departmentCoordinator,
                    callback: function($$v) {
                      _vm.departmentCoordinator = $$v
                    },
                    expression: "departmentCoordinator"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "select"
        ? _c("div", { staticClass: "text-field-wrap" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    }
                  ],
                  staticClass: "exclude-outside-click edit-d-title"
                },
                [_vm._v(_vm._s(_vm.customField.value || "Click to set..."))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-field" },
                [
                  _c("multiselect", {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.outside,
                        expression: "outside"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      }
                    ],
                    ref: "customInput",
                    attrs: {
                      "show-labels": false,
                      options: _vm.getOptions,
                      multiple: false
                    },
                    on: {
                      close: function($event) {
                        _vm.editing = false
                      },
                      input: function($event) {
                        _vm.updateDepartmentFieldValue(_vm.customField)
                        _vm.editing = false
                      }
                    },
                    model: {
                      value: _vm.customField.value,
                      callback: function($$v) {
                        _vm.$set(_vm.customField, "value", $$v)
                      },
                      expression: "customField.value"
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "status"
        ? _c("div", { staticClass: "field-wrap no-icon" }, [
            _vm.customField.value
              ? _c(
                  "span",
                  {
                    staticClass:
                      "exclude-outside-click field-value status-field-value",
                    style: {
                      backgroundColor:
                        _vm.parseValue(_vm.customField.value).color ||
                        _vm.customField.value.color
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.parseValue(_vm.customField.value).name ||
                          _vm.customField.value.name
                      )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.customField.value
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editing,
                        expression: "!editing"
                      }
                    ],
                    staticClass: "exclude-outside-click field-value"
                  },
                  [_vm._v("Click to set...")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "custom-field status-field" },
              [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editing,
                      expression: "editing"
                    }
                  ],
                  staticClass: "custom-field-outside-bg-mobile"
                }),
                _vm._v(" "),
                _c("multiselect", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editing,
                      expression: "editing"
                    },
                    {
                      name: "field-dismiss",
                      rawName: "v-field-dismiss",
                      value: _vm.outside,
                      expression: "outside"
                    }
                  ],
                  ref: "customInput",
                  attrs: {
                    searchable: false,
                    options: _vm.getOptions,
                    "custom-label": _vm.customLabel,
                    "show-labels": false
                  },
                  on: {
                    close: function($event) {
                      _vm.editing = false
                    },
                    input: function($event) {
                      return _vm.updateDepartmentFieldValue(_vm.customField)
                    },
                    select: function($event) {
                      _vm.editing = false
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function(props) {
                          return [
                            _c(
                              "div",
                              {
                                style: {
                                  color: "var(--wf-secondary)",
                                  borderRadius: "10px",
                                  backgroundColor: props.option.color,
                                  height: "40px",
                                  lineHeight: "40px",
                                  textAlign: "center"
                                }
                              },
                              [_vm._v(_vm._s(props.option.name))]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2413709391
                  ),
                  model: {
                    value: _vm.customField.value,
                    callback: function($$v) {
                      _vm.$set(_vm.customField, "value", $$v)
                    },
                    expression: "customField.value"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "users" && _vm.isMultipleField
        ? _c(
            "div",
            { staticClass: "field-wrap no-icon custom-field-users-wrapper" },
            [
              _c(
                "div",
                { staticClass: "field-value exclude-outside-click" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editing,
                          expression: "editing"
                        }
                      ],
                      staticClass: "custom-field user-field custom-multiselect"
                    },
                    [
                      _c("multiselect", {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.outside,
                            expression: "outside"
                          }
                        ],
                        ref: "customInput",
                        attrs: {
                          options: _vm.allActiveUsers,
                          "show-labels": false,
                          "close-on-select": false,
                          multiple: _vm.isMultipleField,
                          "open-direction": "bottom",
                          label: "name",
                          "track-by": "id"
                        },
                        on: {
                          close: function($event) {
                            _vm.editing = false
                          },
                          input: _vm.multipleUsersSelect
                        },
                        model: {
                          value: _vm.selectedUsers,
                          callback: function($$v) {
                            _vm.selectedUsers = $$v
                          },
                          expression: "selectedUsers"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.selectedUsers || _vm.selectedUsers.length == 0
                    ? _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "exclude-outside-click field-value",
                          staticStyle: { display: "inline-block" },
                          attrs: { title: "Click to set..." }
                        },
                        [_vm._v("Click to set...")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.selectedUsers, function(sUser, index) {
                    return _vm.selectedUsers && _vm.selectedUsers.length > 0
                      ? _c(
                          "span",
                          {
                            key: _vm.customField.field_key + "-" + index,
                            staticClass: "info-bubbles"
                          },
                          [
                            sUser.name
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "exclude-outside-click field-value initials badge badge-primary",
                                    staticStyle: { display: "inline-block" },
                                    attrs: {
                                      title:
                                        sUser && sUser.name
                                          ? sUser.name
                                          : "Click to set..."
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("textInitials")(sUser.name)
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "exclude-outside-click field-value",
                                    staticStyle: { display: "inline-block" },
                                    attrs: { title: "Click to set..." }
                                  },
                                  [_vm._v(" Click to set...")]
                                )
                          ]
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "add-multiselect-group" },
                    [
                      _vm.selectedUsers.length > 0
                        ? _c("plus-button")
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "users" && !_vm.isMultipleField
        ? _c("div", { staticClass: "field-wrap" }, [
            _c("div", { staticClass: "field-value " }, [
              _c("span", { staticClass: "info-bubbles" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover",
                        modifiers: { hover: true }
                      }
                    ],
                    staticClass:
                      "exclude-outside-click initials badge badge-primary",
                    staticStyle: { display: "inline-block" },
                    attrs: { title: _vm.customField.userName },
                    on: { click: _vm.checkPosition }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm._f("textInitials")(_vm.customField.userName))
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-multiselect-group" },
                [
                  _c("plus-button"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editing,
                          expression: "editing"
                        }
                      ],
                      staticClass: "custom-field user-field custom-multiselect"
                    },
                    [
                      _c("multiselect", {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.outside,
                            expression: "outside"
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editing,
                            expression: "editing"
                          }
                        ],
                        ref: "customInput",
                        attrs: {
                          options: _vm.allActiveUsers,
                          "option-height": 42,
                          "show-labels": false,
                          multiple: false,
                          "allow-empty": false,
                          label: "name",
                          "track-by": "id"
                        },
                        on: {
                          close: function($event) {
                            _vm.editing = false
                          },
                          input: function($event) {
                            _vm.updateDepartmentFieldValue(_vm.customField)
                            _vm.editing = false
                          }
                        },
                        model: {
                          value: _vm.selectedUser,
                          callback: function($$v) {
                            _vm.selectedUser = $$v
                          },
                          expression: "selectedUser"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "file"
        ? _c("span", [_c("input", { attrs: { type: "file" } })])
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "radio"
        ? _c(
            "span",
            _vm._l(_vm.parseValue(_vm.customField.value_set), function(
              radioValue,
              index
            ) {
              return _c(
                "label",
                { key: "radio" + index, staticClass: "ml-2" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.customField.value,
                        expression: "customField.value"
                      }
                    ],
                    attrs: { type: "radio" },
                    domProps: {
                      value: radioValue,
                      checked: _vm._q(_vm.customField.value, radioValue)
                    },
                    on: {
                      change: [
                        function($event) {
                          return _vm.$set(_vm.customField, "value", radioValue)
                        },
                        function($event) {
                          return _vm.updateDepartmentFieldValue(_vm.customField)
                        }
                      ]
                    }
                  }),
                  _vm._v("\n      " + _vm._s(radioValue) + "\n    ")
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.customField.field_type == "wysiwyg" &&
      _vm.customField.updated_at &&
      _vm.updatedOnTop == false
        ? _c("div", { staticClass: "last-updated last-updated-below" }, [
            _vm._v(
              "\n    Last updated " +
                _vm._s(
                  _vm._f("moment")(_vm.customField.updated_at, "MMM D HH:mm a")
                ) +
                "\n  "
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }